<template>
  <section>
    <div class="wrapper">
      <div class="cmdp_b">
        <div class="sub_list">
          <h2>{{ sendInfo.sendScnNm }} 예약</h2>
          <!--서비스 이용동의-->
          <div class="mgt20">
            <h3 @click="folderInfo.isShowAgr = !folderInfo.isShowAgr">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowAgr" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              서비스 이용동의
            </h3>
            <dl class="box_input" v-show="folderInfo.isShowAgr">
              <dd :class="{'error' : errorTarget === 'isAllChecked'}">
                <div class="checks w100">
                  <input type="checkbox" id="ex_chk1" @click="selectAllAgr(!isAllChecked)" :checked="isAllChecked">
                  <label class="f_b" for="ex_chk1">모두 동의</label>
                </div>
                <div class="checks">
                  <div class="f_r txt_u" @click.stop="onClickPersonalUsageAgreement">보기</div>
                  <input type="checkbox" id="ex_chk2" @click="serviceArgInfo.psiAgrYn = !serviceArgInfo.psiAgrYn"  :checked="serviceArgInfo.psiAgrYn">
                  <label for="ex_chk2"><span class="txt_blue">[필수]</span>개인정보 수집 및 이용동의</label>
                </div>
                <div class="checks">
                  <div class="f_r txt_u" @click.stop="onClickThirdPartyAgreement">보기</div>
                  <input type="checkbox" id="ex_chk3" @click="serviceArgInfo.thirdPartyAgrYn = !serviceArgInfo.thirdPartyAgrYn" :checked="serviceArgInfo.thirdPartyAgrYn">
                  <label for="ex_chk3"><span class="txt_blue">[필수]</span>제3자 개인 정보제공 동의</label>
                </div>
                <div class="checks">
                  <input type="checkbox" id="ex_chk4" @click="serviceArgInfo.ppsScnYn = !serviceArgInfo.ppsScnYn"  :checked="serviceArgInfo.ppsScnYn">
                  <label for="ex_chk4"><span class="txt_blue">[필수]</span>업무용 확인</label>
                </div>
                <div class="checks">
                  <input type="checkbox" id="ex_chk5" @click="serviceArgInfo.securityYn = !serviceArgInfo.securityYn" :checked="serviceArgInfo.securityYn">
                  <label for="ex_chk5"><span class="txt_blue">[필수]</span>보안 스티커 부착 여부</label>
                </div>
              </dd>
            </dl>
          </div>
          <!--무인보관함 가이드-->
          <div class="mgt20" v-if="sendInfo.sendScn !== '01'">
            <h3 @click="folderInfo.isShowLockerGuide = !folderInfo.isShowLockerGuide">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowLockerGuide" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              무인 보관함 가이드
            </h3>
            <div v-show="folderInfo.isShowLockerGuide">
              <locker-guide></locker-guide>
            </div>
          </div>
          <!--보내시는분 정보-->
          <div class="mgt20">
            <h3 @click="folderInfo.isShowSend = !folderInfo.isShowSend">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowSend" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              보내시는분 정보
            </h3>
            <dl class="box_input box_fl" v-show="folderInfo.isShowSend">
              <div>
              <dt>
                이름
              </dt>
              <dd class="box_flex">
                {{ sendInfo.sendNm }}
              </dd>
              </div>
              <div>
              <dt>
                부서
              </dt>
              <dd>
                {{ sendInfo.sendDept }}
              </dd>
              </div>
              <div>
              <dt>
                전화번호
              </dt>
              <dd>
                {{ sendInfo.sendTel }}
              </dd>
              </div>
              <div>
              <dt>이메일</dt>
              <dd>
                {{ sendInfo.sendMailAddr }}
              </dd>
              </div>
              <div>
              <dt>대리발송</dt>
              <dd>
                <div class="small_btn" :class="{orange: (sendInfo.steadYn==='Y'), gray: (sendInfo.steadYn!=='Y')}"
                     @click="sendInfo.steadYn = (sendInfo.steadYn === 'Y' ? 'N' : 'Y'); folderInfo.isShowStead=(sendInfo.steadYn === 'Y');">
                  대리인 지정
                </div>
              </dd>
              </div>
            </dl>
          </div>
          <!--대리발송인 지정 경우-->
          <div class="mgt20">
            <h3 @click="folderInfo.isShowStead = !folderInfo.isShowStead">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowStead" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              대리 발송인 정보
            </h3>
            <dl class="box_input box_fl" v-show="folderInfo.isShowStead">
              <div>
              <dt>
                이름
              </dt>
              <dd class="box_flex">
                <input type="text"
                       :class="{'error' : errorTarget === 'steadNm'}"
                       :disabled="sendInfo.steadYn === 'N'"
                       v-model.trim="sendInfo.steadNm"
                       @input="sendInfo.steadNm=EtnersCommonUtil.cutByteLength(sendInfo.steadNm, 100)"
                       placeholder="이름을 입력하세요.">
              </dd>
              </div>
              <div>
              <dt>
                부서
              </dt>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'steadDept'}"
                       :disabled="sendInfo.steadYn === 'N'"
                       v-model.trim="sendInfo.steadDept"
                       @input="sendInfo.steadDept=EtnersCommonUtil.cutByteLength(sendInfo.steadDept, 500)"
                       placeholder="부서를 입력하세요." >
              </dd>
              </div>
              <div>
              <dt>
                전화번호
              </dt>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'steadTel'}"
                       :disabled="sendInfo.steadYn === 'N'"
                       v-model.trim="sendInfo.steadTel"
                       @input="sendInfo.steadTel=EtnersCommonUtil.cutByteLength(sendInfo.steadTel, 20)"
                       placeholder="전화번호를 입력하세요." >
              </dd>
              </div>
              <div>
              <dt>
              <dt>
                이메일
              </dt>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'steadMailAddr'}"
                       :disabled="sendInfo.steadYn === 'N'"
                       v-model.trim="sendInfo.steadMailAddr"
                       @input="sendInfo.steadMailAddr=EtnersCommonUtil.cutByteLength(sendInfo.steadMailAddr, 200)"
                       placeholder="이메일을 입력하세요." >
              </dd>
              </div>
            </dl>
          </div>
          <!--물품 정보-->
          <div class="mgt20">
            <h3 @click.stop="folderInfo.isShowItem = !folderInfo.isShowItem">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowItem" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              물품 정보
            </h3>
            <dl class="box_input" v-show="folderInfo.isShowItem && sendInfo.sendScn === '01'">
              <dt>발송수단</dt>
              <dd class="box_flex">
                <div v-for="item in deliveryScnList"
                     class="small_btn gray"
                     :class="{orange: (sendInfo.deliveryScn === item.cdId)}"
                     @click="sendInfo.deliveryScn = item.cdId">
                  {{ item.cdNm }}
                </div>
              </dd>
              <dt>내용물</dt>
              <dd class="box_flex">
                <div v-for="item in sendContentsScnList"
                     class="small_btn gray"
                     :class="{orange: (sendInfo.contentsScn === item.cdId)}"
                     @click="sendInfo.contentsScn = item.cdId">
                  {{ item.cdNm }}
                </div>
              </dd>
              <dd class="box_flex" v-if="sendInfo.contentsScn==='03'">
                <div>
                  <input type="text"
                         :class="{'error' : errorTarget === 'contentsScnDesc'}"
                         v-model.trim="sendInfo.contentsScnDesc"
                         @input="sendInfo.contentsScnDesc=EtnersCommonUtil.cutByteLength(sendInfo.contentsScnDesc, 1000)"
                         placeholder="내용물을 입력하세요." >
                </div>
              </dd>
            </dl>
            <dl class="box_input" v-show="folderInfo.isShowItem && sendInfo.sendScn === '02'">
              <dt>
                물품명
              </dt>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'itemNm'}"
                       v-model.trim="sendInfo.itemNm"
                       @input="sendInfo.itemNm=EtnersCommonUtil.cutByteLength(sendInfo.itemNm, 100)"
                       placeholder="물품명을 입력하세요.">
              </dd>
              <dt>
                신고 금액
              </dt>
              <dd>
                <input type="number"
                       min="0"
                       :class="{'error' : errorTarget === 'regCost'}"
                       v-model="sendInfo.regCost"
                       @input="sendInfo.regCost=EtnersCommonUtil.cutByteLength(sendInfo.regCost, 50)"
                       placeholder="신고 금액을 입력하세요." >
              </dd>
<!--              <dt>-->
<!--                수량-->
<!--              </dt>-->
<!--              <dd>-->
<!--                <input type="number"-->
<!--                       min="0"-->
<!--                       :class="{'error' : errorTarget === 'qty'}"-->
<!--                       v-model="sendInfo.qty"-->
<!--                       @input="sendInfo.qty=EtnersCommonUtil.cutByteLength(sendInfo.qty, 2)"-->
<!--                       placeholder="수량을 입력하세요." >-->
<!--              </dd>-->
            </dl>
            <dl class="box_input" v-show="folderInfo.isShowItem && sendInfo.sendScn === '03'">
              <dt>
                운송사 정보
              </dt>
              <dd>
                <kendo-dropdownlist
                    ref="shpcScnRef"
                    class="w100"
                    :data-source="sendShpcScnListExpr"
                    :data-text-field="'cdNm'"
                    :data-value-field="'cdId'"
                    v-model="sendInfo.shpcScn"
                ></kendo-dropdownlist>
              </dd>
              <dt>
                운송장 번호
              </dt>
              <span class="forg">*준비서류: 운송장3+인보이스3(단면복사)</span>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'blNo'}"
                       v-model.trim="sendInfo.blNo"
                       @input="sendInfo.blNo=EtnersCommonUtil.cutByteLength(sendInfo.blNo, 100)"
                       placeholder="운송장 번호를 입력하세요." >
              </dd>
              <dt>
                수량
              </dt>
              <dd>
                <input type="number"
                       min="0"
                       :class="{'error' : errorTarget === 'qty'}"
                       v-model="sendInfo.qty"
                       @input="sendInfo.qty=EtnersCommonUtil.cutByteLength(sendInfo.qty, 2)"
                       placeholder="수량을 입력하세요." >
              </dd>
              <dt>
                우든 포장
              </dt>
              필요시 추가 신청 가능합니다.
              <dd>
                <div class="small_btn w30" :class="{orange: (sendInfo.woodenYn==='Y'), gray: (sendInfo.woodenYn!=='Y')}"
                     @click="sendInfo.woodenYn = (sendInfo.woodenYn === 'Y' ? 'N' : 'Y');">
                  추가
                </div>
              </dd>
            </dl>
          </div>
          <!--받는 분 정보-->
          <div class="mgt20" v-if="sendInfo.sendScn !== '03'">
            <h3 @click="folderInfo.isShowReceive = !folderInfo.isShowReceive">
              <div class="btn_arrow">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path v-if="folderInfo.isShowReceive" stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                  <path v-else stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              받는 분 정보
            </h3>
            <dl class="box_input box_fl" v-show="folderInfo.isShowReceive">
              <div>
              <dt>
                이름
              </dt>
              <dd class="box_flex">
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveNm'}"
                       placeholder="이름을 입력하세요."
                       v-model.trim="sendInfo.receiveNm"
                       @input="sendInfo.receiveNm=EtnersCommonUtil.cutByteLength(sendInfo.receiveNm, 100)">
              </dd>
              </div>
              <div>
              <dt>
                전화번호
              </dt>
              <dd>
                <input type="text"
                       :class="{'error' : errorTarget === 'receiveTel'}"
                       placeholder="전화번호를 입력하세요."
                       v-model.trim="sendInfo.receiveTel"
                       @input="sendInfo.receiveTel=EtnersCommonUtil.cutByteLength(sendInfo.receiveTel, 20)">
              </dd>
              </div>
              <div class="w100">
              <dt>
                주소검색
              </dt>
              <dd>
                <div class="box_flex w100">
                  <div class="small_btn orange mgr15 w20"  @click="onSearchPostCd">주소검색</div>
                  <input type="text"
                        class="w80"
                         :readonly="true"
                         :class="{'error' : errorTarget === 'receiveAddr'}"
                         placeholder="주소를 입력하세요."
                         v-model="receiveAddrWithPostNo"
                         @input="receiveAddrWithPostNo=EtnersCommonUtil.cutByteLength(receiveAddrWithPostNo, 100)">
                </div>
                <input type="text"
                       class="mgt10"
                       :class="{'error' : errorTarget === 'receiveAddrDtl'}"
                       placeholder="상세주소를 입력하세요."
                       v-model.trim="sendInfo.receiveAddrDtl"
                       @input="sendInfo.receiveAddrDtl=EtnersCommonUtil.cutByteLength(sendInfo.receiveAddrDtl, 500)">
              </dd>
              </div>
            </dl>
          </div>
          <div class="box_btn">
            <div class="mid_btn dgray w100" @click="onClickSave">{{ !!sendInfo.sendId ? '저장하기' : '예약하기'}}</div>
          </div>
        </div>
      </div>
    </div>
    <mobile-daum-postcode-window
        ref="daumPostCodeRef"
        v-on:send-addr-data="getAddrData"
    ></mobile-daum-postcode-window>
  </section>
</template>

<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

import MobileDaumPostcodeWindow from "@/components/MobileDaumPostcodeWindow";
import LockerGuide from "@/components/mobile/LockerGuide";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";
import EtnersCommonUtil from "@/common/etners.common.util";

export default {
  name: "ReserveUpsert",
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  components: {MobileDaumPostcodeWindow, LockerGuide},
  created() {
    const vm = this

    if(!!this.$route.params.sendId) {
      // 수정 케이스
      vm.isUpdate = true
      this.getSendDetail()
    } else {
      // 저장 케이스
      // SSO 통해 전달 받은 값
      const userInfo = JSON.parse(sessionStorage.getItem('loginUserData'))
      vm.sendInfo.sendNm = userInfo.userNm
      vm.sendInfo.sendDept = userInfo.deptNm
      vm.sendInfo.sendSabun = userInfo.sabun
      vm.sendInfo.sendTel = userInfo.spTelNo
      vm.sendInfo.sendMailAddr = userInfo.mail

      // 등기, 택배, 해외특송
      let sendScnNm, sendScn, shpcScnNm, shpcScn
      switch (this.$route.params.sendScn) {
        case '01':
          sendScnNm = '등기'
          sendScn = '01'
          shpcScnNm = '우체국'
          shpcScn = '05'
          break
        case '02':
          sendScnNm = '택배'
          sendScn = '02'
          shpcScnNm = '일양택배'
          shpcScn = '04'
          break
        case '03':
          sendScnNm = '해외특송'
          sendScn = '03'
          shpcScnNm = 'DHL'
          shpcScn = '01'
          break
      }

      vm.sendInfo.sendScnNm = sendScnNm
      vm.sendInfo.sendScn = sendScn
      vm.sendInfo.shpcScnNm = shpcScnNm
      vm.sendInfo.shpcScn = shpcScn
    }
  },
  computed: {
    isAllChecked () {
      const vm = this
      for (const key in vm.serviceArgInfo) {
        if(!vm.serviceArgInfo[key]) return false
      }
      return true
    },
    receiveAddrWithPostNo () {
      const vm = this
      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr
      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}`
      }else{
        return ''
      }
    }
  },
  methods: {
    getSendDetail () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: vm.$route.params.sendId,
      }
      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveDetail.json`
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.sendInfo = response.data.resultData

        // 대리발송 여부 체크
        if (vm.sendInfo.steadYn === 'N') {
          vm.sendInfo.steadNm = null
          vm.sendInfo.steadDept = null
          vm.sendInfo.steadTel = null
          vm.sendInfo.steadMailAddr = null
        }
        vm.oldSteadMailAddr = vm.sendInfo.steadMailAddr
        vm.folderInfo.isShowStead = (vm.sendInfo.steadYn === 'Y')

        // 이용동의 세팅
        vm.serviceArgInfo.psiAgrYn = true
        vm.serviceArgInfo.thirdPartyAgrYn = true
        vm.serviceArgInfo.ppsScnYn = true
        vm.serviceArgInfo.securityYn = true
      })

    },
    selectAllAgr (isChecked) {
      const vm = this
      for(const key in vm.serviceArgInfo) {
        vm.serviceArgInfo[key] = isChecked
      }
    },
    getSteadInfo () {
      const vm = this
      const steadYn = vm.sendInfo.steadYn
      let steadInfo = {}

      if (steadYn === 'N') {
        steadInfo.steadNm = vm.sendInfo.sendNm
        steadInfo.steadDept = vm.sendInfo.sendDept
        steadInfo.steadTel = vm.sendInfo.sendTel
        steadInfo.steadMailAddr = vm.sendInfo.sendMailAddr
      }
      return steadInfo
    },
    onSearchPostCd () {
      const vm = this
      const refs = vm.$refs
      refs.daumPostCodeRef.$refs.daumPostCodeRef.kendoWidget().center().open()
    },
    getAddrData (addrData) {
      const vm = this
      vm.sendInfo.receiveAddr = addrData.addr
      vm.sendInfo.receivePost = addrData.zipCode
    },
    onClickSave () {
      const vm = this

      // 유효성 체크
      if (!vm.isAllChecked) {
        kendo.alert('서비스 이용동의를 확인해주세요.')
        vm.errorTarget = 'isAllChecked'
        return
      }
      if(vm.sendInfo.sendScn === '01') { // 등기
        if ('03' === vm.sendInfo.contentsScn && EtnersCommonUtil.isEmpty(vm.sendInfo.contentsScnDesc)) {
          kendo.alert('내용물을 입력해주세요.')
          vm.errorTarget = 'contentsScnDesc'
          return
        }
      }
      if(vm.sendInfo.sendScn === '02') { // 택배
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.itemNm)) {
          kendo.alert('물품명을 입력해주세요.')
          vm.errorTarget = 'itemNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.regCost)) {
          kendo.alert('신고 금액을 입력해주세요.')
          vm.errorTarget = 'regCost'
          return
        } else if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.regCost) && !EtnersLogisticsUtil.isPositiveInteger(vm.sendInfo.regCost)) {
          kendo.alert('신고 금액은 1이상의 숫자만 입력해주세요.')
          vm.errorTarget = 'regCost'
          return
        }
        vm.sendInfo.qty = 1 // 2025-05-12 : 택배 수량 한개로 고정
        // if (EtnersCommonUtil.isEmpty(vm.sendInfo.qty)) {
        //   kendo.alert('수량을 입력해주세요.')
        //   vm.errorTarget = 'qty'
        //   return
        // } else if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.qty) && !EtnersLogisticsUtil.isPositiveInteger(vm.sendInfo.qty)) {
        //   kendo.alert('수량은 1이상의 숫자만 입력해주세요.')
        //   vm.errorTarget = 'qty'
        //   return
        // }
      }
      else if(vm.sendInfo.sendScn === '03') { // 해외특송
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.blNo)) {
          kendo.alert('운송장 번호를 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        }
        if(vm.sendInfo.sendScn === '03' && !EtnersLogisticsUtil.isBlNo(vm.sendInfo.blNo)) {
          kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
          vm.errorTarget = 'blNo'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.qty)) {
          kendo.alert('수량을 입력해주세요.')
          vm.errorTarget = 'qty'
          return
        } else if (EtnersCommonUtil.isNotEmpty(vm.sendInfo.qty) && !EtnersLogisticsUtil.isPositiveInteger(vm.sendInfo.qty)) {
          kendo.alert('수량은 1이상의 숫자만 입력해주세요.')
          vm.errorTarget = 'qty'
          return
        }
      }
      if (vm.sendInfo.steadYn === 'Y') {
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.steadNm)) {
          kendo.alert('대리발송인 이름을 입력해주세요.')
          vm.errorTarget = 'steadNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.steadDept)) {
          kendo.alert('대리발송인 부서를 입력해주세요.')
          vm.errorTarget = 'steadDept'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.steadTel)) {
          kendo.alert('대리발송인 전화번호를 입력해주세요.')
          vm.errorTarget = 'steadTel'
          return
        } else if (!EtnersLogisticsUtil.isTelNum(vm.sendInfo.steadTel)) {
            kendo.alert('대리발송인 전화번호를 형식에 맞게 입력해 주세요.')
            vm.errorTarget = 'steadTel'
            return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.steadMailAddr)) {
          kendo.alert('대리발송인 이메일을 입력해주세요.')
          vm.errorTarget = 'steadMailAddr'
          return
        }else if(!EtnersLogisticsUtil.isEmailDomainAllowed(vm.sendInfo.steadMailAddr)){
            kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg("대리발송인"))
            vm.errorTarget = 'steadMailAddr'
            return
        }
      }
      if(vm.sendInfo.sendScn !== '03') { // 등기, 택배
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.receiveNm)) {
          kendo.alert('받는분 이름을 입력해주세요.')
          vm.errorTarget = 'receiveNm'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.receiveTel)) {
          kendo.alert('받는분 전화번호를 입력해주세요.')
          vm.errorTarget = 'receiveTel'
          return
        } else if (!EtnersLogisticsUtil.isTelNum(vm.sendInfo.receiveTel)) {
            kendo.alert('받는분 전화번호를 형식에 맞게 입력해 주세요.')
            vm.errorTarget = 'receiveTel'
            return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.receiveAddr)) {
          kendo.alert('받는분 주소를 입력해주세요.')
          vm.errorTarget = 'receiveAddr'
          return
        }
        if (EtnersCommonUtil.isEmpty(vm.sendInfo.receiveAddrDtl)) {
          kendo.alert('받는분 상세 주소를 입력해주세요.')
          vm.errorTarget = 'receiveAddrDtl'
          return
        }
      }

      vm.errorTarget = null // flag값 초기화

      // 전화번호 하이픈 제거
      vm.sendInfo.sendTel = vm.sendInfo.sendTel.replaceAll("-", "")
      if(EtnersCommonUtil.isNotEmpty(vm.sendInfo.steadTel)){
        vm.sendInfo.steadTel = vm.sendInfo.steadTel.replaceAll("-", "")
      }
      if(EtnersCommonUtil.isNotEmpty(vm.sendInfo.receiveTel)){
        vm.sendInfo.receiveTel = vm.sendInfo.receiveTel.replaceAll("-", "")
      }

      if(!vm.isUpdate) {
        vm.callSaveApi()
      } else {
        vm.callUpdateApi()
      }
    },
    callSaveApi () {
      const vm = this
      const reserveSendInfo = {
        ...vm.sendInfo,
        ...vm.getSteadInfo()
      }
      const param = {
        loginUserToken: vm.loginUserToken,
        reserveSendInfo: reserveSendInfo
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveSave.json`
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.2')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const sendId = response.data.resultData

        // 예약 확인 메일 전송
        if(vm.sendInfo.steadYn === 'N') {
          // 발신인에게 전송
          vm.callSendMailApi(sendId).then(() => {
            kendo.alert('작성하신 이메일로 사전예약 안내 메일이 발송되었습니다.')
            vm.redirectToDetail(sendId)
          })
        } else {
          kendo.alert('작성하신 이메일에서 사전예약 내용을 확인하실수 있습니다.')
          vm.redirectToDetail(sendId)
        }
      })
    },
    async callSendMailApi (sendId) {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveMail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        sendId: sendId
      }
      const promise = ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.3')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
      })
      await promise
    },
    callUpdateApi () {
      const vm = this
      const reserveSendInfo = {
        ...vm.sendInfo,
        ...vm.getSteadInfo()
      }

      const param = {
        loginUserToken: vm.loginUserToken,
        reserveSendInfo: reserveSendInfo,
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/reserveSend/sendReserveUpdate.json`
      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.5')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        if (vm.oldSteadMailAddr !== vm.sendInfo.steadMailAddr) {
          kendo.alert('작성하신 이메일에서 사전예약 내용을 확인하실수 있습니다.')
        } else {
          kendo.alert('저장되었습니다.')
        }
        vm.redirectToDetail(vm.sendInfo.sendId)
      })
    },
    redirectToDetail (sendId) {
      if(!!!sendId) return
      this.$router.push({
        name: 'ReserveDetail',
        params: {
          sendId: sendId
        }
      })
    },
    onClickPersonalUsageAgreement () {
      window.open("https://etners.com/terms/management/detail/27/02")
    },
    onClickThirdPartyAgreement () {
      window.open("https://etners.com/terms/management/detail/27/07")
    },
  },
  data () {
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      loginUserToken: sessionStorage.getItem('ssoUserToken'),
      isUpdate: false,
      errorTarget: null,
      serviceArgInfo: {
        psiAgrYn: false,
        thirdPartyAgrYn: false,
        ppsScnYn: false,
        securityYn: false,
      },
      oldSteadMailAddr: null,
      sendInfo: {
        sendScn : null,
        statusNm: '예약',
        status: '00',

        sendNm: null, // 발신
        sendDept: null,
        sendSabun: null, // SSO 통해서 가져온다.
        sendTel: null,
        sendMailAddr: null,

        steadYn: "N",
        steadNm: null,
        steadDept: null,
        steadTel: null,
        steadMailAddr: null,

        ppsScn: "02", // 용도
        shpcScn: null,
        blNo: null,
        deliveryScn: "02", // 발송 수단
        contentsScn: "01", // 내용물

        itemNm: null,
        regCost: null,
        qty: null,
        woodenYn: "N",

        receiveNm: null,
        receiveTel: null,
        receiveAddr: null,
        receiveAddrDtl: null,
        receivePost: null,
      },
      folderInfo: {
        isShowAgr: true,
        isShowLockerGuide: true,
        isShowSend: true,
        isShowStead: false,
        isShowItem: true,
        isShowReceive: true,
      },

      facility: null,
      addrData: {}, // 주소 검색 컴포넌트 용
    }
  },
}
</script>

<style scoped>
  .checks input[type="checkbox"]:checked + label:before {
    background: url("~@/assets/img/etners-main/img_check_active.png") no-repeat center center #FE5F40;
    background-size: 100%;
    text-shadow: 1px 1px #fff;
    box-shadow: 0px 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05), inset 15px 10px -12px rgba(255,255,255,0.1);
  }
</style>